var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:_vm.className,staticClass:"echarts_line",style:({ height: (this.height || 530) + 'px' })},[((_vm.chartData || {data: []}).data.length<=0)?_c('div',{staticClass:"nodata"},[_vm._v("暂无数据")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }